import { Box, styled } from '@mui/material';
import { getEntityOptionDisplayLabel } from './utils';
import type { EntityType } from '../../../workflow-sidebar/edit-node-form/nodes/enroll-node-editor/enroll-node-editor.types';

type Props = {
  entityType?: EntityType;
  entityId: { value: string; label: string }[];
};

export const EntityValues = ({ entityId = [] }: Props) => {
  const remainingCount = Math.max(0, entityId.length - 2);

  return (
    <PillsWrapper>
      {entityId.slice(0, 2).map((id, index) => {
        const text = getEntityOptionDisplayLabel(id);
        return (
          <Pill key={`${id}-${index}`} title={text}>
            {text}
          </Pill>
        );
      })}
      {remainingCount > 0 && <Pill>{` + ${remainingCount}`}</Pill>}
    </PillsWrapper>
  );
};

const PillsWrapper = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  justifyContent: 'center',
  verticalAlign: 'middle',
}));

const Pill = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  borderRadius: theme.spacing(2),
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  fontSize: 10,
  lineHeight: 1.4,
  maxWidth: 260,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  textAlign: 'center',
}));
